import axios from "axios";
import Swal from "sweetalert2";

   const BASE_URL = "https://app.areatrek.com/api/";
//  const BASE_URL = "http://localhost:3001"

export const Image_Url =
  process.env.REACT_APP_IMAGE_PATH ||
  "https://areatrek-live-bucket.s3.us-east-2.amazonaws.com/users-profile-images/";

export const Local_Image_Url = "http://localhost:3000/assets/images/users/";


const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// ============================================
// REQUEST
// ============================================

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // If payload is FormData, remove Content-Type so Axios/browser sets boundary automatically
    if (config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers["Content-Type"];
        delete config.headers["content-type"];
      }
    }

    // Login aur forgot-password APIs par
    const isAuthRequest =
      config.url?.includes("/admin/login") ||
      config.url?.includes("/admin/forget-password") ||
      config.url?.includes("/admin/verify-otp") ||
      config.url?.includes("/admin/set-new-password");

    if (token && !isAuthRequest) {
      config.headers.Authorization =
        `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ============================================
// RESPONSE
// ============================================

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => {
    console.error("API ERROR:", error);

    const url = error?.config?.url || "";
    const status = error?.response?.status;



    const isAuthRequest =
      url.includes("/admin/login") ||
      url.includes("/admin/forgot-password") ||
      url.includes("/admin/verify") ||
      url.includes("/admin/reset-password");

    if (isAuthRequest) {
      return Promise.reject(error);
    }

    // ========================================
    // 401
    // ========================================

    if (status === 401) {
      const message =
        error?.response?.data?.message || "";

      if (
        message ===
        "Session terminated by administrator"
      ) {
        Swal.fire({
          title: "Session Terminated",
          text:
            "Your session has been terminated by an administrator. You will be redirected to the login page.",
          icon: "warning",
          confirmButtonColor: "#0b5fb6",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        }).then(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("userData");
          localStorage.removeItem("userName");
          localStorage.removeItem("isLoggedIn");

          window.location.href =
            "/auth/login";
        });

        return Promise.reject(error);
      }

      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      localStorage.removeItem("userName");
      localStorage.removeItem("isLoggedIn");

      if (
        window.location.pathname !==
        "/auth/login" &&
        window.location.pathname !==
        "/auth/verify-2fa-otp"
      ) {
        window.location.href =
          "/auth/login";
      }

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
